import React from 'react';
import CountUp from 'react-countup';
import { AppContext } from '../../App';

import style from './cols.module.scss';

const Cols = ({ cols, className }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;

  const styledValue = (value) => {
    if (typeof value === 'number') {
      return <CountUp start={0} end={value} duration={animationConfig.duration} />;
    }
    return value;
  };

  return (
    <div className={`${style.cols}${className ? ` ${className}` : ''}`}>
      {cols.map(({ title, value, className }, index) => {
        return (
          <div
            key={`col-${title}-${index}`}
            className={`font-mono ${style.col}${className ? ` ${className}` : ''}${
              value !== ''
                ? Array.isArray(value) && value.length <= 0
                  ? ` ${style.skeleton}`
                  : ''
                : ` ${style.skeleton}`
            }`}
          >
            <div className={style.hintText}>{title}</div>
            {Array.isArray(value) ? (
              value.map(({ fact }) => (
                <div key={`${title}-${fact}`} className={style.value}>
                  {styledValue(fact)}
                </div>
              ))
            ) : (
              <div className={style.value}>{styledValue(value)}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export { Cols };
